import type { FC, ReactNode } from 'react'

import { toaster } from '@app/components/ui/toaster'
import ConfirmPopover from '@app/shared/confirmPopover'
import { useAccountDeleteMutation } from '@graphql/queries'
import type { Account } from '@graphql/types'

interface Props {
  account: Account
  body?: string
  children?: ReactNode
}

const AccountDeleteButton: FC<Props> = ({
  account,
  body = "Are you sure you'd like to delete this account?",
  children = null
}) => {
  const [, deleteAccount] = useAccountDeleteMutation()

  const handleDeleteAccount = async () => {
    await deleteAccount({
      input: {
        accountId: account.id
      }
    }).then(() => {
      toaster.create({
        title: 'Account deleted',
        type: 'success'
      })
    })
  }

  return (
    <ConfirmPopover
      onConfirm={() => handleDeleteAccount()}
      header="Delete account"
      body={body}
      confirmButtonText="Confirm"
    >
      {children}
    </ConfirmPopover>
  )
}

export default AccountDeleteButton
